/*
 * One sheet for the four marker pages: they differ in their words and in
 * nothing else, and four identical sheets would be four places to edit the day
 * the markers gain a shape.
 */
.page {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 42rem;
}

.title {
  margin: 0;
  font-size: 1.5rem;
}

.body {
  margin: 0;
  color: var(--text-muted);
}

.identifier {
  margin: 0;
  font-family: ui-monospace, monospace;
}

.back {
  align-self: flex-start;
  color: var(--text);
}

.back:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
